export function getRgbPercentagesArrayFromString(string) {
  return string
    .split(",")
    .map((string) => string.trim())
    .map(Number)
    .map((n) => n / 255);
}
